/** Retention or policy revision changed; restart this scope from sequence zero. */
export class ListingResetError extends Error {
  constructor() {
    super('Listing reset')
    this.name = 'ListingResetError'
  }
}
